import { Field, Formik, Form, ErrorMessage } from "formik";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import successToast from "../../components/toasts/successToast";
import logo from "../../assets/images/acumenVelocityLogo.svg";
import { Image, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import errorToast from "../../components/toasts/errorToast";
import { forgotPasswordAction } from "../../redux/actions/authAction";

const ForgotPassword = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const initialValues = {
        email: "",
        password: "",
    };

    const [loading, setLoading] = useState(false);
    const onSuccess = (data) => {
        successToast(data.data.message);
        setLoading(false);
    };
    const onError = (data) => {
        setLoading(false);
        errorToast(data.data.message);
    };

    const validationSchema = Yup.object().shape({
        email: Yup.string().required("Required").email("Invaild Email"),
    });

    const onSubmit = (values) => {
        console.log('dhfgiudsfgiusdfgsiudfgsiudg');

        const dispatchingValues = {
            email: values.email
        }
        dispatch(forgotPasswordAction(dispatchingValues, onSuccess, onError))
        setLoading(true);
    };
    return (
        <div
            className="min-vh-100 d-flex flex-column"
            style={{ backgroundColor: "#E9EEF7" }}
        >
            <div
                className="d-flex align-items-center cursor_pointer p-2"
                style={{ height: "8vh" }}
                onClick={() => navigate("/")}
            >
                <Image alt="logo" src={logo} height={40} className="mx-2" />
                <p className="name fs_18 fw_600 m-0 ">Acumen Translation Hub</p>
            </div>
            <div className="flex-grow-1 d-flex flex-column justify-content-center align-items-center fn_Roboto">
                <div className="bg-light border-opacity-10  border d-flex flex-column justify-content-center align-items-center py-5 px-3 rounded-2  gap-2 col-12 col-md-8 col-lg-4">
                    <h4 className="fw_500 fn_Roboto">Forgot Password</h4>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                    >
                        {({ values, setFieldValue, isValid, dirty }) => (
                            <Form className="h-100 justify-content-between w-100 px-5">
                                <div>
                                    <div className="text-start gap-3 mb-2 text-nowrap">
                                        <label htmlFor="email" className="py-1">
                                            Email
                                        </label>
                                        <div className="d-flex position-relative">
                                            <Field
                                                name="email"
                                                className="input-field w-100"
                                                id="email"
                                                placeHolder="Enter Email"
                                            />
                                        </div>
                                        <ErrorMessage
                                            name="email"
                                            component="div"
                                            className="text-danger mt-1 fs_12"
                                        />
                                    </div>
                                </div>
                                {loading && (
                                    <div className="d-flex align-items-center text-center">
                                        <Spinner size="sm" className="text-primary" />{" "}
                                        <span className="ms-2">Sending...</span>
                                    </div>
                                )}
                                <div className="d-flex justify-content-between mt-4 gap-2">
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={loading}
                                    >
                                        Send Link
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        disabled={loading}
                                        onClick={() => navigate("/translation-page")}
                                    >
                                        Back To Login
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </div>
    );
}

export default ForgotPassword;
